module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /Users/jonathan/Skypager/~/babel-runtime/regenerator/index.js
// module id = ../../node_modules/babel-runtime/regenerator/index.js
// module chunks = 0